import { StudentStudyApi, StudentYearEnum } from "../Api";
import { arrayParamAjust } from "../utils/dataUtils";
import { getAuthConfiguration } from "./configuration";

const AuthStudentStudyApiFactory = () =>
	new StudentStudyApi(getAuthConfiguration());

export const getStudentStudyPrograms = (studentId: string) => {
	return AuthStudentStudyApiFactory().apiStudentStudyGetStudentStudyProgramsGet(
		{ studentId }
	);
};

export const getCurrentStudentStudyProgram = () => {
	return AuthStudentStudyApiFactory().apiStudentStudyGetCurrentStudentStudyProgramGet();
};

export const getCurrentStudentStudyProgramForStudent = (studentId: string) => {
	return AuthStudentStudyApiFactory().apiStudentStudyGetCurrentStudentStudyProgramForStudentGet(
		{ studentId }
	);
};

export const setCurrentStudentStudyProgram = async (
	studyProgramId: string,
	year?: StudentYearEnum
) => {
	await AuthStudentStudyApiFactory().apiStudentStudySetCurrentStudentStudyProgramPut(
		{ studyProgramId, year }
	);
};

export const setCurrentStudentStudyProgramAdmin = async (
	studentId: string,
	studyProgramId: string
) => {
	await AuthStudentStudyApiFactory().apiStudentStudySetCurrentStudentStudyProgramAdminPut(
		{ studentId, studyProgramId }
	);
};

export const getStudyProgramsAdmin = (
	facultyId: string,
	studyCycle?: string
) => {
	console.warn("student-study-requests");

	return AuthStudentStudyApiFactory().apiStudentStudyGetStudyProgramsAdminGet({
		facultyId,
		studyCycle,
	});
};

export const getStudyProgramsForFaculties = (facultyIds?: Array<string>) => {
	console.warn("student-study-requests");

	return AuthStudentStudyApiFactory().apiStudentStudyGetStudyProgramsGet({
		facultyIds: arrayParamAjust(facultyIds),
	});
};

export const getReportStudyPrograms = () => {
	return AuthStudentStudyApiFactory().apiStudentStudyGetReportsStudyProgramsGet();
};

export const getAvailableStudyProgramsForStudent = () => {
	return AuthStudentStudyApiFactory().apiStudentStudyGetPossibleStudyProgramsForCurrnetStudentGet();
};

export const getAvailableStudyPrograms = (supervisorId: string) => {
	return AuthStudentStudyApiFactory().apiStudentStudyGetAvailableStudyProgramsSupervisorIdGet(
		{ supervisorId }
	);
};

export const getSupervisedStudyPrograms = (
	supervisorId: string,
	namePattern: string,
	page: number,
	pageSize: number
) => {
	return AuthStudentStudyApiFactory().apiStudentStudyGetSupervisedStudyProgramsSupervisorIdGet(
		{ supervisorId, namePattern, page, pageSize }
	);
};

export interface SupervisedStudyProgramsProps {
	search?: string; //namePattern
	supervisorId: string;
	page?: number; //page
	pageSize?: number; //pageSize
}

export const getSupervisedStudyProgramsV2 = (
	props: SupervisedStudyProgramsProps
) => {
	const { search: namePattern, supervisorId, page, pageSize } = props;

	return AuthStudentStudyApiFactory().apiStudentStudyGetSupervisedStudyProgramsSupervisorIdGet(
		{ supervisorId, namePattern, page, pageSize }
	);
};
